var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"bottom-copyright"},[_c('span',[_vm._v("© 2021 极致音乐版权所有")]),_vm._v(" | "),_c('span',[_vm._v("粤ICP备88888888号")])]),_c('img',{staticClass:"bottom-logo",attrs:{"src":require("@/assets/images/logo.png")}})])
}]

export { render, staticRenderFns }